import React from 'react'
const Logout = () => {
  return (
    <>
      <h1>logoput</h1>
    </>
  )
}
export default Logout
